import type { IFieldConfig } from './types'

export const renderLabel = (config: IFieldConfig, configs?: IFieldConfig[]) => {
  if (config.labelRender && config.label) {
    const Label = config.labelRender
    return <Label config={config} configs={configs} />
  }
  return config.label
}

export const renderInfo = (config: IFieldConfig, configs?: IFieldConfig[]) => {
  if (config.infoRender && config.info) {
    const Info = config.infoRender
    return <Info config={config} configs={configs} />
  }
  return config.info
}

export const renderDescription = (config: IFieldConfig, configs?: IFieldConfig[]) => {
  if (config.descriptionRender && config.description) {
    const Description = config.descriptionRender
    return <Description config={config} configs={configs} />
  }
  return config.description
}
